
export default {
  data() {
      return {

        //   joomlaUrl: "https://mygems.serasi.tech",
        //   joomlaUrl: "https://mygems.alami.my/",
        //   joomlaUrl: "https://mygems.jmg.gov.my/",

          

        //   vueUrl: "https://apis.spatialworks.com.my/mygis/",

        // joomlaUrl: "https://mygems.jmg.gov.my/",
        //   vueUrl: "https://mygems.alami.my/mygis/",

        //   loginPortalUrl: "https://mygems.alami.my/portal/sharing/rest/oauth2/authorize?client_id=SEzwt9WquUQV8nSQ&display=default&response_type=code&redirect_uri=https://mygems.alami.my/geodatahub/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri"
        
        docUrl: "",
        joomlaUrl: "",
        vueUrl: "",
        loginPortalUrl: ""

      }
  },    
  mounted(){

        this.setGlobalUrl();
      
  },
  methods: {

        // Set which global domain should be selected
        setGlobalUrl(){

            if(location.host.includes("8080")){

                if(localStorage.localhostMyGEMSLogin != undefined){
                    if(localStorage.localhostMyGEMSLogin == 'jmg'){
                        this.docUrl = "https://mygems.jmg.gov.my/";
                        this.joomlaUrl = "https://mygems.jmg.gov.my/home/";
                        this.vueUrl = "https://mygems.jmg.gov.my/mygis/";
                        this.loginPortalUrl = "https://mygems.jmg.gov.my/portal/sharing/rest/oauth2/authorize?client_id=MiW0HeUupa7Fxblz&display=default&response_type=code&redirect_uri=https://mygems.jmg.gov.my/geodatahub/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                    }
                    else if(localStorage.localhostMyGEMSLogin == 'alami'){
                        this.docUrl = "https://mygems.alami.my/";
                        this.joomlaUrl = "https://mygems.alami.my/";
                        this.vueUrl = "https://mygems.alami.my/mygis/";
                        this.loginPortalUrl = "https://mygems.alami.my/portal/sharing/rest/oauth2/authorize?client_id=SEzwt9WquUQV8nSQ&display=default&response_type=code&redirect_uri=https://mygems.alami.my/geodatahub/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                    }
                }
                
            }
            else{
                if(location.host.includes("jmg")){
                    this.docUrl = "https://mygems.jmg.gov.my/";
                    this.joomlaUrl = "https://mygems.jmg.gov.my/home/";
                    this.vueUrl = "https://mygems.jmg.gov.my/mygis/";
                    this.loginPortalUrl = "https://mygems.jmg.gov.my/portal/sharing/rest/oauth2/authorize?client_id=MiW0HeUupa7Fxblz&display=default&response_type=code&redirect_uri=https://mygems.jmg.gov.my/geodatahub/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                }
                else if(location.host.includes("alami")){
                    this.docUrl = "https://mygems.alami.my/";
                    this.joomlaUrl = "https://mygems.alami.my/";
                    this.vueUrl = "https://mygems.alami.my/mygis/";
                    this.loginPortalUrl = "https://mygems.alami.my/portal/sharing/rest/oauth2/authorize?client_id=SEzwt9WquUQV8nSQ&display=default&response_type=code&redirect_uri=https://mygems.alami.my/geodatahub/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                }
            }

        },

        docUrlReturn(){
            if(location.host.includes("8080")){

                if(localStorage.localhostMyGEMSLogin != undefined){
                    if(localStorage.localhostMyGEMSLogin == 'jmg'){
                        this.docUrl = "https://mygems.jmg.gov.my/";
                    }
                    else if(localStorage.localhostMyGEMSLogin == 'alami'){
                        this.docUrl = "https://mygems.alami.my/";
                    }
                }
                
            }
            else{
                if(location.host.includes("jmg")){
                    this.docUrl = "https://mygems.jmg.gov.my/";
                }
                else if(location.host.includes("alami")){
                    this.docUrl = "https://mygems.alami.my/";
                }
            }
            return this.docUrl;
        },

        vueUrlReturn(){
            if(location.host.includes("8080")){
                if(localStorage.localhostMyGEMSLogin != undefined){
                    if(localStorage.localhostMyGEMSLogin == 'jmg'){
                        this.vueUrl = "https://mygems.jmg.gov.my/mygis/";
                    }
                    else if(localStorage.localhostMyGEMSLogin == 'alami'){
                        this.vueUrl = "https://mygems.alami.my/mygis/";
                    }
                }
                
            }
            else{
                if(location.host.includes("jmg")){
                    this.vueUrl = "https://mygems.jmg.gov.my/mygis/";
                }
                else if(location.host.includes("alami")){
                    this.vueUrl = "https://mygems.alami.my/mygis/";
                }
            }

            return this.vueUrl;
        },

        joomlaUrlReturn(){
            if(location.host.includes("8080")){
                if(localStorage.localhostMyGEMSLogin != undefined){
                    if(localStorage.localhostMyGEMSLogin == 'jmg'){
                        this.joomlaUrl = "https://mygems.jmg.gov.my/home/";
                    }
                    else if(localStorage.localhostMyGEMSLogin == 'alami'){
                        this.joomlaUrl = "https://mygems.alami.my/";
                    }
                }
                
            }
            else{
                if(location.host.includes("jmg")){
                    this.joomlaUrl = "https://mygems.jmg.gov.my/home/";
                }
                else if(location.host.includes("alami")){
                    this.joomlaUrl = "https://mygems.alami.my/";
                }
            }

            return this.joomlaUrl;
        },

        loginPortalUrlReturn(){
            if(location.host.includes("8080")){
                if(localStorage.localhostMyGEMSLogin != undefined){
                    if(localStorage.localhostMyGEMSLogin == 'jmg'){
                        this.loginPortalUrl = "https://mygems.jmg.gov.my/portal/sharing/rest/oauth2/authorize?client_id=MiW0HeUupa7Fxblz&display=default&response_type=code&redirect_uri=https://mygems.jmg.gov.my/geodatahub/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                    }
                    else if(localStorage.localhostMyGEMSLogin == 'alami'){
                        this.loginPortalUrl = "https://mygems.alami.my/portal/sharing/rest/oauth2/authorize?client_id=SEzwt9WquUQV8nSQ&display=default&response_type=code&redirect_uri=https://mygems.alami.my/geodatahub/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                    }
                }
                
            }
            else{
                if(location.host.includes("jmg")){
                    this.loginPortalUrl = "https://mygems.jmg.gov.my/portal/sharing/rest/oauth2/authorize?client_id=MiW0HeUupa7Fxblz&display=default&response_type=code&redirect_uri=https://mygems.jmg.gov.my/geodatahub/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                }
                else if(location.host.includes("alami")){
                    this.loginPortalUrl = "https://mygems.alami.my/portal/sharing/rest/oauth2/authorize?client_id=SEzwt9WquUQV8nSQ&display=default&response_type=code&redirect_uri=https://mygems.alami.my/geodatahub/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                }
            }

            return this.loginPortalUrl;
        },

        // Function for jump page
        goToPage(url){
            this.$router.push({ path: url }).catch(()=>{});
        },

        // Function for jump to main page (Joomla Portal)
        backToLandingPage(){
            window.location.href = this.joomlaUrl;
        },

        logout(){
            // this.$store.dispatch('signOut');
            this.goToPage("/logout");
        },

        displayRM(value){

            let CurrencyFormat = new Intl.NumberFormat('en-MY', {
                style: 'currency',
                currency: 'MYR'
            })
            
            let valueInRM = CurrencyFormat.format(value)

            return valueInRM;

        },

        // To use, put this line of code => @keypress="isNumber($event)" in element
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        // Get Size from size input file to display in standard format
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'
        
            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        
            const i = Math.floor(Math.log(bytes) / Math.log(k))
        
            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },

        CreateUUID() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            )
        },

        // Datetime Ui Display - Standardize Date Format
        displayUiDatetime(datetime){

            // console.log(datetime);

            if(datetime != null && datetime != "-" && datetime != "" && datetime.trim().length != 0 ){

                if(datetime.includes("T")){
                    datetime = datetime.replace("T"," ")
                }

                let [date, time] = datetime.split(' ');

                // Convert Date Format
                var dd = date.split("-")[2];
                var mm = date.split("-")[1];
                var yyyy = date.split("-")[0];
                let stringMM = [
                    {noMM: "01", strMM:"Januari"},
                    {noMM: "02", strMM:"Februari"},
                    {noMM: "03", strMM:"Mac"},
                    {noMM: "04", strMM:"April"},
                    {noMM: "05", strMM:"Mei"},
                    {noMM: "06", strMM:"Jun"},
                    {noMM: "07", strMM:"Julai"},
                    {noMM: "08", strMM:"Ogos"},
                    {noMM: "09", strMM:"September"},
                    {noMM: "10", strMM:"Oktober"},
                    {noMM: "11", strMM:"November"},
                    {noMM: "12", strMM:"Disember"},
                ];
                for(let i in stringMM){
                    if (stringMM[i].noMM == mm) {
                        mm = stringMM[i].strMM;
                    }
                }
                date = dd + " " + mm + " " + yyyy;

                // Convert Time to Format 12 hours
                var H = +time.substr(0, 2);
                // if(H.toString().length == 1){
                //     H += 0+H;
                // }
                // console.log(H);

                var h = H % 12 || 12;
                var ampm = (H < 12 || H === 24) ? "AM" : "PM";
                // time = h + time.substr(2, 3) + time.substr(5, 3) + ' ' + ampm;
                time = h + time.substr(2, 3) + time.substr(5, 3) + ' ' + ampm;
                
                datetime = date + ",<br>" + time;

                return datetime;

            }
            else if (datetime == "-")
            {
                return "-"
            }
            else{
                return null
            }

        },

        displayUiBackStandardDt(datetime){

            // console.log(datetime);

            if(datetime != null && datetime != "" && datetime != "-"){
                
                let date = datetime.split(",<br>")[0];
                let time = datetime.split(",<br>")[1];

                // Change Date
                var yyyy = date.split(" ")[2];
                var mm = date.split(" ")[1];
                var dd = date.split(" ")[0];
                let stringMM = [
                    {noMM: "01", strMM:"Januari"},
                    {noMM: "02", strMM:"Februari"},
                    {noMM: "03", strMM:"Mac"},
                    {noMM: "04", strMM:"April"},
                    {noMM: "05", strMM:"Mei"},
                    {noMM: "06", strMM:"Jun"},
                    {noMM: "07", strMM:"Julai"},
                    {noMM: "08", strMM:"Ogos"},
                    {noMM: "09", strMM:"September"},
                    {noMM: "10", strMM:"Oktober"},
                    {noMM: "11", strMM:"November"},
                    {noMM: "12", strMM:"Disember"},
                ]
                for(let i in stringMM){
                    if (stringMM[i].strMM == mm) {
                        mm = stringMM[i].noMM;
                    }
                }
                let new_date = yyyy + "-" + mm + "-" + dd;

                // Change Time
                const [timeNew, modifier] = time.split(' ');
                let [hours, minutes, seconds] = timeNew.split(':');
                if (hours === '12'){   
                    hours = '00';
                }
                if(hours.length == 1){
                    hours = 0+hours;
                }
                
                if (modifier === 'PM'){
                    hours = parseInt(hours, 10) + 12;
                }

                let new_time = hours + ":" + minutes + ":" + seconds

                let new_datetime = new_date + " " + new_time;

                // console.log(new_datetime);

                return new_datetime;

            }
            else{
                return null;
            }

        },

        // Date Ui Display - Standardize Date Format
        displayUiDate(date){

            if(date != null && date != "-" && date != "" && date.trim().length != 0 ){

                // Convert Date Format
                var dd = date.split("-")[2];
                var mm = date.split("-")[1];
                var yyyy = date.split("-")[0];
                let stringMM = [
                    {noMM: "01", strMM:"Januari"},
                    {noMM: "02", strMM:"Februari"},
                    {noMM: "03", strMM:"Mac"},
                    {noMM: "04", strMM:"April"},
                    {noMM: "05", strMM:"Mei"},
                    {noMM: "06", strMM:"Jun"},
                    {noMM: "07", strMM:"Julai"},
                    {noMM: "08", strMM:"Ogos"},
                    {noMM: "09", strMM:"September"},
                    {noMM: "10", strMM:"Oktober"},
                    {noMM: "11", strMM:"November"},
                    {noMM: "12", strMM:"Disember"},
                ];
                for(let i in stringMM){
                    if (stringMM[i].noMM == mm) {
                        mm = stringMM[i].strMM;
                    }
                }
                date = dd + " " + mm + " " + yyyy;

                return date

            }
            else if (date == "-")
            {
                return "-"
            }
            else{
                return null
            }

        },
      
  },
  computed: {

      roleViewer() {
          return this.$store.getters.user.roleId === 'iAAAAAAAAAAAAAAA' ? true : false
      },

      roleDataEditor() {
          return this.$store.getters.user.roleId === 'iBBBBBBBBBBBBBBB' ? true : false
      },

      roleAdmin() {
          return this.$store.getters.user.roleId === 'meGoBHCZkMThgQFy' ? true : false
      },

      rolePengurusGeoportal() {
          return this.$store.getters.user.roleId === 'oi7FmliBR1xpPLcG' ? true : false
      },

      rolePengurusPermohonanAnalisis() {
          return this.$store.getters.user.roleId === 'yDnc6e9ksGDHlXMr' ? true : false
      },

      rolePengurusPermohonanData() {
          return this.$store.getters.user.roleId === 'sVCZhFyoYRjXob95' ? true : false
      },

      rolePengurusAduan() {
          return this.$store.getters.user.roleId === 'zKw5xhYA8Ww6CUY7' ? true : false
      },

      rolePenyuntingData() {
          return this.$store.getters.user.roleId === 'cIsIH4JWyR7OZzIY' ? true : false
      },

      rolePengesahData() {
          return this.$store.getters.user.roleId === 'OMckR8VNssIFvkS6' ? true : false
      },

      rolePemohonData() {
          return this.$store.getters.user.roleId === 'cBktxTSkpqgTWOAU' ? true : false
      },

      rolePemohonAnalisis() {
          return this.$store.getters.user.roleId === 'nba0cipRaNkI7noA' ? true : false
      },

      rolePenggunaEksekutif() {
          return this.$store.getters.user.roleId === 'W4vKMPGQyATJxaED' ? true : false
      },

      rolePenggunaBerdaftar() {
          return this.$store.getters.user.roleId === 'lesIQBWkQWEbuTxl' ? true : false
      },

      roleMyGemsAdmin() {
          return this.$store.getters.user.roleId === 'KQGpHe1xyMy8G7Fs' ? true : false
      },

  },
}